module.exports = __webpack_public_path__ + "static/media/business-solution-bro-business.4311b70b.svg";